import { Attendee, AttendeeActivity } from 'src/types/types';
import { API_INSTANCE, buildURLWithState } from 'src/features/utils';

export async function fetchAttendeeActivitiesApi(state: unknown, id: Attendee['id']) {
  return await API_INSTANCE.get<AttendeeActivity[]>(
    buildURLWithState(state, `/api/v1/dashboard/attendee-activity/${id}`)
  );
}
